import React from 'react';
import * as ReactDOM from 'react-dom';
import { Button, Modal, Toast, ListView, Icon, Carousel } from 'antd-mobile';
import moment from 'moment';

import './index.less';

  var timer1 = null
  var timer2 = null

  class RowItem extends React.Component {
    render() {
      const { content, activedId, index } = this.props;
      return (
        <div className={activedId === content ? `br_item${index} active` : `br_item${index}`} id={`br_item_${content}`}>
        </div>
      )
    }
  }

class hundredDaysActivitiesShare extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            urlOps: {},
            data: [],
            skipCount: 0,
            pageSize: 10,
            listData: ['2222','2222','33333'],
            sharkNum: 0,
            activityCode: null,
            visible: false,
            activityEnable: true,
            successVisible: false,
            examVisible: false,
            todayVisible: false,
            noTimeVisible: false,
            shakeCode: null,
            winResult: {},
            // 九宫格内容list
            list: [1, 2, 3, 4, 5, 6, 7, 8],
            indexs: [1,2,3,4,5,6,7,8],
            // 被选中的格子的ID
            activedId: '',
            // 中奖ID
            prizeId: null,
            // 获得prizeId之后计算出的动画次数
            times: 0,
            // 当前动画次数
            actTimes: 0,
            // 是否正在抽奖
            isRolling: false,
            // 转盘速度
            speed: 200,
            prizeToCode: {}
        };
    }
        

    componentWillMount() {
        this.init()
    }


    init(){
        this.doShine()
        
    }
    
    doShine(){
    timer1 = setInterval(() => {
        document.querySelector('.br_border1').classList.remove('hidden')
        document.querySelector('.br_border2').classList.add('hidden')
    }, 1000);
    timer2 = setInterval(() => {
        document.querySelector('.br_border1').classList.add('hidden')
        document.querySelector('.br_border2').classList.remove('hidden')
    }, 2000);
}
    
   
    doShake(){
        window.location.href = 'https://www.hellogil.com/appDownload/#/HuilianDownload'
    }

    render() {
        const {data, urlOps, activityCode, sharkNum, visible, successVisible, winResult, todayVisible, noTimeVisible, activityResult, failureVisible,prizeId,list, activedId,indexs,listData} = this.state;

        return (
            <div className='br_bg'>
                <div className='main-bg'>
    
                </div>
                
                <div className='br_middle'>
                    <div className='br_border1 hidden'></div>
                    <div className='br_border2'></div>
                    <div ></div>
                    <RowItem content={list[0]} index={indexs[0]} activedId={activedId} />
                    <RowItem content={list[1]} index={indexs[1]} activedId={activedId} />
                    <RowItem content={list[2]} index={indexs[2]} activedId={activedId} />
                    <RowItem content={list[7]} index={indexs[3]} activedId={activedId} />
                    <div className='br_button_bg'>
                        <div className='br_button' onClick={() => this.doShake()}></div>
                    </div>
                    <RowItem content={list[3]} index={indexs[4]} activedId={activedId} />
                    <RowItem content={list[6]} index={indexs[5]} activedId={activedId} />
                    <RowItem content={list[5]} index={indexs[6]} activedId={activedId} />
                    <RowItem content={list[4]} index={indexs[7]} activedId={activedId} />
                </div>
                <div className='br_activity' style={{ paddingTop: '0.18rem' }}>
                    <div className='activity-box'>
                            <div className='activity-logo'>
                                <div className='activity-logo-left'></div>
                                <div className='activity-logo-title'>活动规则</div>
                                <div className='activity-logo-right'></div>
                            </div>
                            <div className='br_content'>
                                <p>1、抽奖时间：2023年2月1日0：00-2023年2月7日23：59。</p>
                                <p>2、抽奖对象：2022年11月1日-2022年11月30日成功报名“百日挑战”的用户。</p>
                                <p>3、抽奖资质：于开奖日（2月1日）前100天内未出险或未产生违章则可获得1次抽奖机会，两者均未产生则获得2次抽奖机会，两者均产生则失去抽奖资质。</p>
                                <p>4、领奖方式：抽中华为matepad11、海尔272升冰箱、美的洗衣机等实物奖品的用户，客服将在7日内联系您前往现场领奖，由工作人员核对中奖信息后发放奖品；抽中100元、500元充电金的用户，奖品将在7个工作日内发放至您的充电卡账户内，前往我的-充电卡可查看充电金到账情况；抽中5元、10元、30元充电券的用户，奖品将在7个工作日内发放至您的账户内，前往我的-优惠券可查看到账情况。</p>
                                <p>5、本次活动最终解释权归主办方所有，与苹果（Apple Inc.）无关。</p>
                            </div>
                        </div>
                    </div>
            </div>
        );
    }
}
export default hundredDaysActivitiesShare;


// WEBPACK FOOTER //
// ./src/hundredDaysActivities/share/index.js